import mixpanel from 'mixpanel-browser';
import config from './config/environment';


export const initializeMixpanel = () => {
  // Set up an instance of Mixpanel
  mixpanel.init('7bae86944c46952e59058567d73422df');
};

export const trackEvent = (
  eventName: string,
  eventProperties?: any,
) => {
  if (config.env === "development") { console.log('Mixpanel Event-->  ', eventName, eventProperties); }
  if (eventProperties) {
    mixpanel.track(eventName, eventProperties);
  } else {
    mixpanel.track(eventName);
  }
  return;
};

export const identifyUser = (userId: string) => {
  if (config.env === "development") { console.log('user is identified', userId); }
  mixpanel.identify(userId);
};

export const setUserProperties = (name: string, value: any) => {
  if (config.env === "development") { console.log('setting user property', name, ': ', value); }
  mixpanel.people.set(name, value);
};

export const resetUser = () => {
  mixpanel.reset();
};
